import '@/styles/bank-recorded-badge.css';

/** Tooltip for the "Bank matched" icon on a receive payment. */
export function formatBankRecordedTitle(bankRecord, formatDate, formatCurrency) {
  if (!bankRecord) return 'Recorded in bank statement';
  const via = bankRecord.via === 'deposit' ? ' (via bank deposit)' : '';
  const amount = formatCurrency(Math.abs(Number(bankRecord.amount) || 0));
  return `Recorded in bank statement${via}: ${formatDate(bankRecord.transactionDate)} · ${amount}`;
}
